/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DocumentRefreshIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Document Refresh',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M20 0h.086a1 1 0 0 1 .706.292L27.708 7.2a1 1 0 0 1 .292.714V8h-8Z" />
    <path
      d="M14 27a13 13 0 0 1 13-13c.338 0 .669.025 1 .05V10h-9a1 1 0 0 1-1-1V0H5a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h10a12.956 12.956 0 0 1-1-5ZM35.605 29.549a8.883 8.883 0 0 1-15.501 3.09l-1.25 1.251a.489.489 0 0 1-.35.148.5.5 0 0 1-.504-.501v-5a.5.5 0 0 1 .5-.5h4.999a.502.502 0 0 1 .501.504.489.489 0 0 1-.147.35l-1.74 1.74a6.057 6.057 0 0 0 10.597-1.436.977.977 0 0 1 .921-.62h1.25a.759.759 0 0 1 .724.974Z"
    />
    <path
      d="M18.395 24.526a8.883 8.883 0 0 1 15.501-3.091l1.25-1.25a.489.489 0 0 1 .35-.148.5.5 0 0 1 .504.5v5a.5.5 0 0 1-.5.5h-4.999a.502.502 0 0 1-.501-.504.489.489 0 0 1 .147-.35l1.74-1.74A6.057 6.057 0 0 0 21.29 24.88a.977.977 0 0 1-.921.62h-1.25a.759.759 0 0 1-.724-.974Z"
    />
  </svg>`;
};
